import http from '@/utils/request';
import login from './login';
import home from './home';
var api = Object.assign({}, http, login, home);
export default api;